'use client';

import { forwardRef, useImperativeHandle, useRef } from 'react';

export interface HoneypotHandle {
	isFilled: () => boolean;
}

const Honeypot = forwardRef<HoneypotHandle>((_, ref) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useImperativeHandle(ref, () => ({
		isFilled: () => !!inputRef.current?.value
	}));

	return (
		<input
			ref={inputRef}
			type="text"
			name="company_url"
			autoComplete="off"
			tabIndex={-1}
			aria-hidden="true"
			style={{ display: 'none' }}
		/>
	);
});

export default Honeypot;
